import { useContext, useEffect, useMemo, useState } from "react";
import { RiZoomInLine, RiZoomOutLine } from "react-icons/ri";
import {
	// ScrollMode,
	SpecialZoomLevel,
	Viewer,
	Worker,
} from "@react-pdf-viewer/core";

import { Icon, MinimalButton, Position, Tooltip } from "@react-pdf-viewer/core";
// Plugins
import { zoomPlugin } from "@react-pdf-viewer/zoom";
import disableScrollPlugin from "./custom-plugins/disable-scroll.plugin";
import { pageNavigationPlugin } from "@react-pdf-viewer/page-navigation";

import InputField from "components/input-field/input-field.component";
import FileSelector from "components/file-selector/file-selector.component";

import { FolderContext } from "src/contexts/folder.context";

// Import the styles
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "./pdf-viewer.style.scss";
import useTranslate from "src/hooks/use-translate";

const PdfViewer = ({ viewOriginal = false }) => {
	const {
		openedFile,
		focusedFiles: { files },
		openFile,
		updateRef,
		getUpdatedFile,
	} = useContext(FolderContext);

	const { file, ref } = useMemo(() => openedFile, [openedFile]);

	const [shownFile, setShownFile] = useState(null);
	const [openedFileIndex, setOpenedFileIndex] = useState(0);

	const t = useTranslate("Archive");

	// useEffect(() => {
	// 	const getFileFromLink = async () => {
	// 		if (!openedFile) return;

	// 		console.log({ openedFile });

	// 		fetch(openedFile.url)
	// 			.then((res) => res.json())
	// 			.then((res) => console.log(res))
	// 			.catch((err) => console.log({ err }));
	// 	};

	// 	getFileFromLink();
	// }, [openedFile]);

	const zoomPluginInstance = zoomPlugin();
	const {
		// CurrentScale,
		ZoomIn,
		ZoomOut,
	} = zoomPluginInstance;

	const disableScrollPluginInstance = disableScrollPlugin();

	const pageNavigationPluginInstance = pageNavigationPlugin();
	const { GoToPreviousPage, GoToNextPage, CurrentPageLabel } = pageNavigationPluginInstance;

	useEffect(() => {
		const initializeFile = async () => {
			if (file) {
				let reader = new FileReader();

				reader.onloadend = (e) => {
					setShownFile(e.target.result);
				};

				if (viewOriginal) {
					reader.readAsDataURL(file);
					setOpenedFileIndex(files.findIndex(({ file: _file }) => _file.name === file.name) + 1);

					return;
				}

				reader.readAsDataURL(await getUpdatedFile(file, ref));

				setOpenedFileIndex(files.findIndex(({ file: _file }) => _file.name === file.name) + 1);
			}
		};

		initializeFile();
	}, [file, ref, files, viewOriginal, getUpdatedFile]);

	const handleClose = () => {
		openFile();
	};

	const handleChangeRef = ({ target: { value } }) => {
		updateRef(value);
	};

	return (
		<div className="pdf-viewer-container" style={{ zIndex: 10 }}>
			{shownFile && (
				<Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
					<div className="pdf-viewer-topbar">
						<div className="left-side">
							<div className="left-side-box">
								<div className="title">{t("reference")}</div>
								<InputField
									className="body"
									fieldType="invisible"
									placeholder="N/A"
									value={ref}
									onChange={handleChangeRef}
								/>
							</div>
							<div className="left-side-box">
								<div className="title">{t("name")}</div>
								<div className="body">{file.name}</div>
							</div>
						</div>
						<div className="center">
							{t("page")}
							<CurrentPageLabel>
								{(props) => <span>{`${props.currentPage + 1} / ${props.numberOfPages}`}</span>}
							</CurrentPageLabel>
						</div>
						<div className="right-side">
							<ZoomOut>
								{(props) => <RiZoomOutLine className="zoom-icon" onClick={props.onClick} />}
							</ZoomOut>
							<ZoomIn>
								{(props) => <RiZoomInLine className="zoom-icon" onClick={props.onClick} />}
							</ZoomIn>
							<div
								style={{
									fontSize: "2.4vh",
									color: "white",
								}}
								onClick={handleClose}
							>
								X
							</div>
						</div>
					</div>
					<div className="pdf-viewer">
						<div
							style={{
								left: 0,
								position: "absolute",
								top: "50%",
								transform: "translate(24px, -50%)",
								zIndex: 1,
								// flex: 1,
								// paddingInline: "20px",
								// display: "flex",
								// alignItems: "center",
							}}
						>
							<GoToPreviousPage>
								{(props) => (
									<Tooltip
										position={Position.BottomCenter}
										target={
											<MinimalButton onClick={props.onClick}>
												<Icon size={16}>
													<path d="M18.4.5,5.825,11.626a.5.5,0,0,0,0,.748L18.4,23.5" />
												</Icon>
											</MinimalButton>
										}
										content={() => "Previous page"}
										offset={{ left: 0, top: 8 }}
									/>
								)}
							</GoToPreviousPage>
						</div>
						<Viewer
							// fileUrl={"https://s2.q4cdn.com/175719177/files/doc_presentations/Placeholder-PDF.pdf"}
							// fileUrl={openedFile?.url ?? shownFile}
							fileUrl={shownFile}
							plugins={[
								zoomPluginInstance,
								disableScrollPluginInstance,
								pageNavigationPluginInstance,
							]}
							// scrollMode={ScrollMode.Wrapped}
							defaultScale={SpecialZoomLevel.PageFit}
						/>
						<div
							style={{
								position: "absolute",
								right: 0,
								top: "50%",
								transform: "translate(-24px, -50%)",
								zIndex: 1,
								// flex: 1,
								// paddingInline: "20px",
								// display: "flex",
								// alignItems: "center",
							}}
						>
							<GoToNextPage>
								{(props) => (
									<Tooltip
										position={Position.BottomCenter}
										target={
											<MinimalButton onClick={props.onClick}>
												<Icon size={16}>
													<path d="M5.651,23.5,18.227,12.374a.5.5,0,0,0,0-.748L5.651.5" />
												</Icon>
											</MinimalButton>
										}
										content={() => "Next page"}
										offset={{ left: 0, top: 8 }}
									/>
								)}
							</GoToNextPage>
						</div>
					</div>
					<div className="pdf-viewer-bottombar">
						<div className="file-count-container">{`${openedFileIndex}/${files.length.toString()}`}</div>
						<FileSelector />
					</div>
				</Worker>
			)}
		</div>
	);
};

export default PdfViewer;
